module.exports = __webpack_public_path__ + "img/jianding-h.50a5fa68.svg";